import { defineComponent as _defineComponent } from 'vue'
import { withModifiers as _withModifiers, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "selected-client" }
const _hoisted_2 = ["title"]
const _hoisted_3 = {
  key: 0,
  class: "selected-client__holding"
}

import { ref } from "vue";
import AppIcon from "@/components/ui-kit/icon/AppIcon.vue";
import AppResizableDropdown from "@/components/ui-kit/dropdown/AppResizableDropdown.vue";
import ProjectClientRoleDropdown from "@/components/main/search-panel/dropdowns/ProjectClientRoleDropdown.vue";
import { CommonEntityRecord } from "@/models/interfaces/common";
import { searchStore } from "@/store/search";
import { useBreakpoints } from "@/composables/useBreakpoints";


export default /*@__PURE__*/_defineComponent({
  __name: 'ProjectSelectedClientItem',
  props: {
    client: {},
    roleEditable: { type: Boolean, default: true },
    removable: { type: Boolean, default: true }
  },
  emits: ['remove', 'change', 'open-filter'],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const store = searchStore()
const { isMobile } = useBreakpoints()

const $roleDropdownRef = ref<InstanceType<typeof AppResizableDropdown> | null>(null)

const closeRoleDropdown = () => $roleDropdownRef.value?.close()

const onRemoveRole = (roleId: number) => {
	store.detachRoleFromSelectedClient(props.client.Id, roleId)
	emit('change')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(AppIcon, {
      class: "selected-client__filter-icon",
      name: "filter",
      size: "14px",
      color: "#979797",
      "hover-color": "#499259",
      cursor: "pointer",
      title: _ctx.$t('show_in_filter'),
      "data-client-filter-chip": "",
      onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (emit('open-filter')), ["stop"]))
    }, null, 8, ["title"]),
    _createElementVNode("span", {
      class: "selected-client__name",
      title: _ctx.$t('show_in_filter'),
      "data-client-filter-chip": "",
      onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (emit('open-filter')), ["stop"]))
    }, [
      _createTextVNode(_toDisplayString(_ctx.client.Name), 1),
      (_ctx.client.UseUnion)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, " " + _toDisplayString(_ctx.$t('with_holding_suffix')), 1))
        : _createCommentVNode("", true)
    ], 8, _hoisted_2),
    (_ctx.roleEditable)
      ? (_openBlock(), _createBlock(AppResizableDropdown, {
          key: 0,
          ref_key: "$roleDropdownRef",
          ref: $roleDropdownRef,
          position: "right",
          "close-by-click-outside": true,
          "max-width": 400,
          "max-height": 436,
          name: "$dropdownSelectedClientRole"
        }, {
          activator: _withCtx(() => [
            _createVNode(AppIcon, {
              class: "selected-client__hash",
              name: "hash",
              size: "16px",
              color: "#979797",
              "hover-color": "#499259",
              cursor: "pointer",
              title: _ctx.$t('role_attach')
            }, null, 8, ["title"])
          ]),
          default: _withCtx(() => [
            _createVNode(ProjectClientRoleDropdown, {
              "client-id": _ctx.client.Id,
              "attached-roles": _ctx.client.Roles,
              "show-close-icon": _unref(isMobile),
              onChange: _cache[2] || (_cache[2] = ($event: any) => (emit('change'))),
              onClose: closeRoleDropdown
            }, null, 8, ["client-id", "attached-roles", "show-close-icon"])
          ]),
          _: 1
        }, 512))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.client.Roles, (role) => {
      return (_openBlock(), _createElementBlock("span", {
        key: role.Id,
        class: "selected-client__role"
      }, [
        _createTextVNode(_toDisplayString(role.Name) + " ", 1),
        _createVNode(AppIcon, {
          class: "selected-client__role-delete",
          name: "close-bold",
          size: "12px",
          color: "#D2D2D2",
          "hover-color": "#4D4D4D",
          cursor: "pointer",
          onClick: _withModifiers(($event: any) => (onRemoveRole(role.Id)), ["stop"])
        }, null, 8, ["onClick"])
      ]))
    }), 128)),
    (_ctx.removable)
      ? (_openBlock(), _createBlock(AppIcon, {
          key: 1,
          class: "selected-client__delete",
          name: "close-bold",
          size: "12px",
          color: "#D2D2D2",
          "hover-color": "#4D4D4D",
          cursor: "pointer",
          onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (emit('remove')), ["stop"]))
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})